(function ($) {
  // DOMContentLoadedとloadの両方で実行
  function initSidebarColor() {
    var headerFontWt = (function () {
      // 初期状態を即座に設定
      function updateSidebarColor() {
        var wself = $(window);
        var offset = 0;
        var windowTop = wself.scrollTop() + offset;
        var windowBtm = wself.scrollTop() + wself.height() - offset;
        var hasTarget = false;

        $('.is-target').each(function () {
          var self = $(this);
          var targetPosTop = self.offset().top;
          var targetPosBtm = self.offset().top + self.outerHeight();

          if (windowBtm >= targetPosTop && windowTop <= targetPosBtm) {
            // 表示中スライドが black_text の場合はヘッダーも黒のままにする
            hasTarget = self.attr('data-black-text') !== 'true';
            return false; // break the loop
          }
        });

        if (hasTarget) {
          $('.sidebar').addClass('is-white');
        } else {
          $('.sidebar').removeClass('is-white');
        }
      }

      // 初期実行
      updateSidebarColor();

      // イベントリスナーを設定
      $(window).on('load scroll resize', updateSidebarColor);
      // スライダーのスライド切替（black_text 変化）に追従
      $(document).on('ssk:hero-color-change', updateSidebarColor);
    })();
  }

  // DOMContentLoadedで即座に実行
  $(document).ready(function () {
    initSidebarColor();
    // JavaScriptが読み込まれたことを示すクラスを追加
    $('body').removeAttr('js-loading');
  });

  // loadイベントでも実行（画像などが読み込まれた後）
  $(window).on('load', function () {
    initSidebarColor();
    // JavaScriptが読み込まれたことを示すクラスを追加
    $('body').removeAttr('js-loading');
  });
})($);
